export default __webpack_public_path__ + "static/media/dashboard-banner-image.f163c05b.png";